import { Image, soundManager, t, useVoucherStore } from '@slot-nx/core'
import { gameConfig } from '../../../config'
import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { Container as PixiContainer } from 'pixi.js'
import gsap from 'gsap'
import { VoucherHeaderPayout } from './VoucherHeaderPayout'
import { useGameStore } from '../../../domain/game/store/GameStore'
import { VoucherSoundType } from '../../../domain/soundManager/enum/VoucherSoundType'

const bounceHeader = (header: PixiContainer, icon: PixiContainer) => {
  soundManager.play(VoucherSoundType.headerShow)
  gsap.set(header, { y: -150 })
  gsap.timeline()
    .to(icon, {
      y: 250,
      ease: 'power2.out',
      duration: 0.5,
    }, 0)
    .to(icon.scale, {
      x: 2,
      y: 2,
      ease: 'power2.out',
      duration: 0.5,
    }, 0) // 同樣 offset 0，同步
    .to({}, { duration: 0.3 })
    .to(header, {
      y: 0, // 回到原位
      duration: 0.6,
      ease: 'bounce.out',
    })
    .to(icon, {
      y: 50, // 回到原位
      ease: 'bounce.out',
      duration: 0.6,
      onStart: () => {
        soundManager.play(VoucherSoundType.giftIconBounce)
      },
    }, '<')
    .to(icon.scale, {
      x: 1,
      y: 1,
      ease: 'bounce.out',
      duration: 0.6,
    }, '<') // '<' 表示和上面的動畫同時開始
}

export const VoucherHeader = () => {
  const [remainSpin, totalSpin, totalPayout] = useVoucherStore(x => [x.remainSpin, x.totalSpin, x.totalPayout])
  const isVoucherTime = useGameStore(x => x.isVoucherTime)
  const headerRef = useRef<PixiContainer>()
  const iconRef = useRef<PixiContainer>()
  useEffect(() => {
    if (headerRef.current && iconRef.current && isVoucherTime) {
      bounceHeader(headerRef.current, iconRef.current)
    }
  }, [isVoucherTime])
  return (
    <Container name="VoucherHeader" visible={isVoucherTime} ref={(el) => { headerRef.current = el as PixiContainer }}>
      <Image name="voucher_header"image="voucher_bg"width={1080}height={103}anchor={[0.5, 0]}x={gameConfig.resolution.width / 2}y={0} />
      <Text
        text={t('voucher_header_round_title')}
        x={250}
        y={30}
        anchor={[0.5, 0.5]}
        name="FREE BONUS SPINS"
        style={new TextStyle({
          align: 'center',
          fontWeight: '600',
          fill: '#FFBF00',
          fontFamily: 'Roboto',
          fontSize: 27,

        })}
      />
      <Text
        text={`${remainSpin}/${totalSpin}`}
        x={250}
        y={70}
        anchor={[0.5, 0.5]}
        name="Rounds"
        style={new TextStyle({
          align: 'center',
          fontWeight: 'normal',
          fill: '#FFFFFF',
          fontFamily: 'RobotoCondensed',
          fontSize: 35,
        })}
      />
      <Container name="icon" ref={(el) => { iconRef.current = el as PixiContainer }} x={540} y={50}>
        <Image
          name="voucher_icon_light"
          image="voucher_halo"
          width={140}
          height={140}
          anchor={[0.5, 0.5]}
          x={0}
          y={0}
        />
        <Image
          name="voucher_icon"
          image="voucher_gift"
          width={53}
          height={61}
          anchor={[0.5, 0.5]}
          x={0}
          y={0}
        />
      </Container>

      <VoucherHeaderPayout totalPayout={totalPayout} />
    </Container>

  )
}
